import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTooltip } from '@angular/material/tooltip';
import { isString } from 'lodash-es';
import {
  AccessTokenErrorCodes,
  AuthService,
  isHttpErrorResponse,
  UserService,
} from '@ipg/ngx-frontend-toolset';
import { GlobalLoadersService } from '../../global-loaders.service';
import { DialogService } from '../dialog/dialog.service';

@Component({
  selector: 'app-header',
  imports: [MatToolbar, MatIcon, MatIconButton, MatTooltip, MatProgressBarModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  public static readonly LOADER_ID = `header_loader`;

  private readonly _auth = inject(AuthService);
  private readonly _dialog = inject(DialogService);
  private readonly _snackbar = inject(MatSnackBar);
  private readonly _userService = inject(UserService);
  protected readonly globalLoaders = inject(GlobalLoadersService);
  protected readonly loaderId = HeaderComponent.LOADER_ID;

  protected readonly currentUser = this._userService.data();

  logout(): void {
    this._auth.logout().subscribe({
      next: () => {
        this._snackbar.open('Je bent succesvol uitgelogd.', 'Begrepen');
      },
      error: (e) => {
        if (isHttpErrorResponse(e)) {
          const { errorCode } = e.error.detail;

          if (
            isString(errorCode) &&
            Object.values(AccessTokenErrorCodes).includes(
              errorCode as AccessTokenErrorCodes
            )
          ) {
            return;
          }
        }
        this._dialog.alert({
          title: 'Foutmelding',
          message: 'Er gaat iets fout bij het uitloggen. Probeer het later nog eens.',
          confirmText: 'OK',
        });
      },
    });
  }
}
